const ITEMS = [
  "Verified Franchise Listings",
  "5% AMC · ₹100 Flat Fee per Trade",
  "CCD / NCD Backed Instruments",
  "Passive Monthly Coupons",
  "Offer to Buy · Offer to Sell Liquidity",
  "60:40 Capital Structure",
  "frantiger — Your Business, Our Priority",
];

export default function Marquee() {
  const track = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-y border-orange-100 bg-white py-4" data-testid="marquee-strip">
      <div className="marquee-track gap-10">
        {track.map((item, i) => (
          <span key={i} className="flex items-center gap-3 whitespace-nowrap text-sm font-bold uppercase tracking-[0.15em] text-slate-500">
            <span className="h-2 w-2 rounded-full bg-orange-500" />
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}
